// extracted by mini-css-extract-plugin
module.exports =  {"location":"SfTO8r","locationOld":"n8AaDc","countryPickerButton":"ceTrzD"};